import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import SignUpScreenContent from "./SignUpScreenContent";
import TermsAndCondition from "./TermsAndCondition";
import PrivacyPolicy from "./PrivacyPolicy";
import FAQs from "./FAQs";
import Button from "../../components/Button";
import Spinner from "../../components/Spinner";
import { showToast } from "../../store/slices/common";
import { getTncPolicyData, saveTncPolicyData } from "../../http/common";
import Sponsors from "./Sponsors";
import HelpAndSupport from "./HelpAndSupport";
import Resources from "./Resources";

function TabPanel(props) {
  const { children, value, index, smScreen, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            padding: smScreen ? "0 0 16px 0" : "0 2.5% 16px",
            height: {
              xs: "calc(100vh - 170px)",
              md: "calc(100vh - 160px)",
              xl: "calc(100vh - 175px)",
            },
            overflowY: "auto",
          }}
          className="setting-right"
        >
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function TabsComponent({ collapse }) {
  const [value, setValue] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [preFillData, setPreFillData] = useState({});
  const [disabled, setDisabled] = useState(false);

  const theme = useTheme();
  const dispatch = useDispatch();

  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setEdit(false);
    setDisabled(false);
  };

  useEffect(() => {
    getTncPolicy(2);
    getTncPolicy(3);
  }, [value]);

  const getTncPolicy = async (val) => {
    setLoading(true);
    try {
      const type = val == 2 ? "terms" : "privacy";
      const res = await getTncPolicyData(type);
      const resData = res.data.data;
      setLoading(false);
      if (resData) {
        if (val == 2) {
          setFormData((prev) => ({
            ...prev,
            termsAndCondition: { ...resData?.description },
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            privacyPolicy: { ...resData?.description },
          }));
        }
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        showToast({
          color: "error",
          msg: error.response?.data?.message || error.message,
        })
      );
    }
  };

  const onChangeContent = (e, key) => {
    checkDisabled(edit, value, formData, preFillData, setDisabled);
    setFormData({ ...formData, [key]: e.target.value });
  };

  const onChangeTextEditor = (e, key) => {
    checkDisabled(edit, value, formData, preFillData, setDisabled);
    const formDataClone = { ...formData };
    if (value === 2) {
      formDataClone["termsAndCondition"] = {
        ...formDataClone["termsAndCondition"],
        [key]: e,
      };
    } else {
      formDataClone["privacyPolicy"] = {
        ...formDataClone["privacyPolicy"],
        [key]: e,
      };
    }
    setFormData(formDataClone);
  };

  const submitData = async () => {
    if (!edit) {
      setEdit(!edit);
      setDisabled(true);
    } else {
      try {
        setLoading(true);
        let data = new FormData();
        if (value === 0) {
          data.append("walkThroughScreensTitles", formData.walkThroughTitle1);
          data.append("walkThroughScreensTitles", formData.walkThroughTitle2);
          data.append("walkThroughScreensTitles", formData.walkThroughTitle3);
          data.append(
            "walkThroughScreensContents",
            formData.walkThroughContent1
          );
          data.append(
            "walkThroughScreensContents",
            formData.walkThroughContent2
          );
          data.append(
            "walkThroughScreensContents",
            formData.walkThroughContent3
          );
          if (formData.walkThroughScreens[0])
            data.append("walkThroughScreens", formData.walkThroughScreens[0]);
          if (formData.walkThroughScreens[1])
            data.append("walkThroughScreens", formData.walkThroughScreens[1]);
          if (formData.walkThroughScreens[2])
            data.append("walkThroughScreens", formData.walkThroughScreens[2]);
        } else if (value === 1) {
          data.append("signInScreenTitle", formData.signInScreenTitle);
          data.append(
            "signInScreenDescription",
            formData.signInScreenDescription
          );
        } else if (value === 2) {
          data.append("signUpScreenTitle", formData.signUpScreenTitle);
          data.append(
            "signUpScreenDescription",
            formData.signUpScreenDescription
          );
        } else if (value === 3) {
          data.append("bannerRedirectUrl", formData.bannerRedirectUrl);
          if (formData.bannerImage)
            data.append("bannerImage", formData.bannerImage);
        }

        await setupHome(data);
        setLoading(false);

        // disable edit mode
        setEdit(false);

        dispatch(
          showToast({ color: "success", msg: "Data updated successfully" })
        );
      } catch (error) {
        setLoading(false);
        dispatch(
          showToast({
            color: "error",
            msg: error.response?.data?.message || error.message,
          })
        );
      }
    }
  };

  const updateTermsAndPrivacy = async () => {
    if (!edit) {
      setEdit(!edit);
      setDisabled(true);
    } else {
      try {
        setLoading(true);
        const payload = {
          title: " ",
          type: value === 2 ? "terms" : "privacy",
          description:
            value === 2 ? formData.termsAndCondition : formData.privacyPolicy,
        };
        await saveTncPolicyData(payload);
        setLoading(false);

        // disable edit mode
        setEdit(false);

        dispatch(
          showToast({ color: "success", msg: "Data updated successfully" })
        );
      } catch (error) {
        setLoading(false);
        dispatch(
          showToast({
            color: "error",
            msg: error.response?.data?.message || error.message,
          })
        );
      }
    }
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
        display: isMobile ? "block" : "flex",
      }}
      className={`custom-vertical-tab-box ${collapse ? "collapse-tabs" : ""}`}
    >
      {loading && <Spinner />}
      <Tabs
        orientation={isMobile ? "horizontal" : "vertical"}
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{
          width: smScreen ? "100%" : "180px",
          minWidth: smScreen ? "100%" : "180px",
          borderRight: 1,
          borderColor: "rgba(3, 41, 58, 0.20)",
        }}
      >
        <Tab
          label={
            <Box
              display={"flex"}
              alignItems={"center"}
              width={"100%"}
              textAlign="right"
            >
              <Typography variant={"span"} component={"span"}>
                Resources
              </Typography>
            </Box>
          }
          {...a11yProps(0)}
          sx={{
            paddingLeft: 0,
            "&.Mui-selected": { color: "#0832DE !important" },
          }}
        />
        <Tab
          label={
            <Box
              display={"flex"}
              alignItems={"center"}
              width={"100%"}
              textAlign="right"
            >
              <Typography variant={"span"} component={"span"}>
                Sponsors/ Partners
              </Typography>
            </Box>
          }
          {...a11yProps(1)}
          sx={{
            paddingLeft: 0,
            "&.Mui-selected": { color: "#0832DE !important" },
          }}
        />
        <Tab
          label={
            <Box
              display={"flex"}
              alignItems={"center"}
              width={"100%"}
              textAlign="right"
            >
              <Typography variant={"span"} component={"span"}>
                Terms & Conditions
              </Typography>
            </Box>
          }
          {...a11yProps(2)}
          sx={{
            paddingLeft: 0,
            "&.Mui-selected": { color: "#0832DE !important" },
          }}
        />
        <Tab
          label={
            <Box
              display={"flex"}
              alignItems={"center"}
              width={"100%"}
              textAlign="right"
            >
              <Typography variant={"span"} component={"span"}>
                Privacy Policy
              </Typography>
            </Box>
          }
          {...a11yProps(3)}
          sx={{
            paddingLeft: 0,
            "&.Mui-selected": { color: "#0832DE !important" },
          }}
        />
        <Tab
          label={
            <Box
              display={"flex"}
              alignItems={"center"}
              width={"100%"}
              textAlign="right"
            >
              <Typography variant={"span"} component={"span"}>
                FAQs
              </Typography>
            </Box>
          }
          {...a11yProps(4)}
          sx={{
            paddingLeft: 0,
            "&.Mui-selected": { color: "#0832DE !important" },
          }}
        />
        <Tab
          label={
            <Box
              display={"flex"}
              alignItems={"center"}
              width={"100%"}
              textAlign="right"
            >
              <Typography variant={"span"} component={"span"}>
                Help and Support
              </Typography>
            </Box>
          }
          {...a11yProps(5)}
          sx={{
            paddingLeft: 0,
            "&.Mui-selected": { color: "#0832DE !important" },
          }}
        />
      </Tabs>
      <TabPanel
        style={{ width: "100%" }}
        value={value}
        index={0}
        smScreen={smScreen}
      >
        <TabWrapper
          edit={edit}
          disabled={disabled}
          submitData={submitData}
          value={value}
        >
          <Resources />
        </TabWrapper>
      </TabPanel>
      <TabPanel
        style={{ width: "100%" }}
        value={value}
        index={1}
        smScreen={smScreen}
      >
        <TabWrapper value={value}>
          <Sponsors />
        </TabWrapper>
      </TabPanel>{" "}
      <TabPanel
        style={{ width: "100%" }}
        value={value}
        index={2}
        smScreen={smScreen}
      >
        <TabWrapper
          edit={edit}
          disabled={disabled}
          submitData={updateTermsAndPrivacy}
          value={value}
        >
          <TermsAndCondition
            edit={edit}
            formData={formData}
            onChangeTextEditor={onChangeTextEditor}
          />
        </TabWrapper>
      </TabPanel>
      <TabPanel
        style={{ width: "100%" }}
        value={value}
        index={3}
        smScreen={smScreen}
      >
        <TabWrapper
          edit={edit}
          disabled={disabled}
          submitData={updateTermsAndPrivacy}
          value={value}
        >
          <PrivacyPolicy
            edit={edit}
            formData={formData}
            onChangeTextEditor={onChangeTextEditor}
          />
        </TabWrapper>
      </TabPanel>
      <TabPanel
        style={{ width: "100%" }}
        value={value}
        index={4}
        smScreen={smScreen}
      >
        <TabWrapper value={value}>
          <FAQs />
        </TabWrapper>
      </TabPanel>
      <TabPanel
        style={{ width: "100%" }}
        value={value}
        index={5}
        smScreen={smScreen}
      >
        <TabWrapper value={value}>
          <HelpAndSupport />
        </TabWrapper>
      </TabPanel>
    </Box>
  );
}

const TabWrapper = ({ children, edit, value, disabled, submitData }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        padding: {
          xs: "0.75rem 0",
          sm: "0.75rem 1rem",
          md: "0.75rem 1rem",
          lg: "0.75rem 1rem",
          xl: "0.75rem 1rem",
        },
        boxSizing: "border-box",
      }}
    >
      {children}
      {(value === 2 || value === 3) && (
        <Button
          style={{ marginTop: "1rem", width: "180px" }}
          onClick={submitData}
          disabled={disabled}
        >
          {!edit && (
            <DriveFileRenameOutlineOutlinedIcon sx={{ marginRight: "8px" }} />
          )}
          {edit ? "Save Changes" : "Edit"}
        </Button>
      )}
    </Box>
  );
};

const checkDisabled = (edit, value, formData, preFillData, setDisabled) => {
  if (!edit) setDisabled(false);
  else if (
    value === 0 &&
    formData.walkThroughTitle1 &&
    formData.walkThroughTitle2 &&
    formData.walkThroughTitle3 &&
    formData.walkThroughContent1 &&
    formData.walkThroughContent2 &&
    formData.walkThroughContent3 &&
    (formData.walkThroughScreens?.length >= 1 ||
      preFillData.walkThroughScreens?.length >= 1)
  ) {
    setDisabled(false);
  } else if (
    value === 1 &&
    formData.signInScreenTitle &&
    formData.signInScreenDescription
  ) {
    setDisabled(false);
  }
  // else if (
  //   value === 2 &&
  //   formData.signUpScreenTitle &&
  //   formData.signUpScreenDescription
  // ) {
  //   setDisabled(false);
  // } else if (value === 3 && (preFillData.bannerImage || formData.bannerImage)) {
  //   setDisabled(false);
  // }
  else if (
    value === 2 &&
    (preFillData.termsAndCondition || formData.termsAndCondition)
  ) {
    setDisabled(false);
  } else if (
    value === 3 &&
    (preFillData.privacyPolicy || formData.privacyPolicy)
  ) {
    setDisabled(false);
  } else if (value === 6 && formData.faqs && formData.faqs.length > 0) {
    const check = formData.faqs.every((faq) => faq.question && faq.answer);
    if (check) setDisabled(false);
    else setDisabled(true);
  } else {
    setDisabled(true);
  }
};
